import React, { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { observer } from 'mobx-react-lite';
import TableContext from './TableContext';
import TableHeaderCell from './TableHeaderCell';
const TableVirtualHeaderCell = function TableVirtualHeaderCell(props) {
    const { columnGroup } = props;
    const { tableStore } = useContext(TableContext);
    const { ref, inView } = useInView({
        root: tableStore.node.wrapper,
        rootMargin: '100px',
        initialInView: true,
    });
    useEffect(() => {
        columnGroup.setInView(inView);
        return () => {
            if (columnGroup.inView !== undefined) {
                columnGroup.setInView(undefined);
            }
        };
    }, [columnGroup, inView]);
    return (React.createElement(TableHeaderCell, Object.assign({}, props, { intersectionRef: ref })));
};
TableVirtualHeaderCell.displayName = 'TableVirtualHeaderCell';
export default observer(TableVirtualHeaderCell);
